import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-receiving-icon',
  templateUrl: './receiving-icon.component.html',
  styles: []
})
export class ReceivingIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
